/**
 * Правки текста сообщения КП для МСК Газобетона.
 *
 * Своего текста здесь ровно две строки: шапка и итог. Перечисление позиций,
 * доставки и услуг собирается прежним кодом Offer.js по строкам блоков — там
 * стоит точная номенклатура выбранного производства и та доставка, которая
 * соответствует выбранному варианту КП.
 *
 * Вне области обе функции возвращают базовые строки 5442898 дословно.
 */

import { resolveGazCashTotal, buildGazCashRoundingNote } from './gazCashRounding.js';

const BASE_INTRO_TAIL = 'стоимость запрашиваемых материалов:';

/** Номер сделки указан по-настоящему, а не пришёл как null/undefined/пустая строка. */
export const hasOrderNumber = (dealId) => {
  if (dealId === null || dealId === undefined) {
    return false;
  }
  const text = String(dealId).trim();
  return text !== '' && text !== 'null' && text !== 'undefined';
};

/**
 * Шапка сообщения. Внутри области при отсутствующем номере строка с номером
 * убирается целиком — «По заказу №null» в текст не попадает.
 */
export const buildGazMessageIntro = ({ dealId, isMskGazobetonScope } = {}) => {
  if (!isMskGazobetonScope || hasOrderNumber(dealId)) {
    return `По заказу №${dealId} ${BASE_INTRO_TAIL}`;
  }
  // Без номера заказа фраза начинается с сути.
  return `Стоимость запрашиваемых материалов:`;
};

/**
 * Итоговые строки. Внутри области при наличных сумма округляется тем же
 * gazCashRounding, что и итог на экране, и рядом поясняется разница.
 *
 * @returns {string[]} строки итога в порядке показа
 */
export const buildGazMessageTotalLines = ({
  total,
  paymentMethod,
  isMskGazobetonScope,
  formatPrice = (value) => String(value),
} = {}) => {
  const cash = resolveGazCashTotal({ total, isMskGazobetonScope, paymentMethod });

  if (!cash.applies) {
    return [`Общая сумма: ${formatPrice(total)} руб.`];
  }

  const lines = [`Итого к оплате: ${cash.total.toLocaleString('ru-RU')} ₽`];
  const note = buildGazCashRoundingNote(cash);
  if (note) {
    lines.push(note);
  }
  return lines;
};

export default buildGazMessageIntro;
